import { Link } from "react-router-dom";

type AppointmentOverlayVerificationProps = {
  patientInfoPath: string | null;
  onVerify: () => void;
};

const AppointmentOverlayVerification = ({
  patientInfoPath,
  onVerify,
}: AppointmentOverlayVerificationProps) => (
  <div className="appointment-overlay__body appointment-overlay__verify">
    <div className="appointment-overlay__body-header">
      <span className="appointment-overlay__body-title">Verify patient</span>
      {patientInfoPath && (
        <Link to={patientInfoPath} className="appointment-overlay__verify-link">
          Edit patient info
          <span className="material-symbols-outlined" aria-hidden="true">
            north_east
          </span>
        </Link>
      )}
    </div>

    <p className="appointment-overlay__verify-text">
      Before starting the visit, confirm you&apos;re speaking with the right patient.
    </p>

    <p className="appointment-overlay__verify-text appointment-overlay__verify-check">
      <strong>Verify name, DOB, and physical address</strong>
      <br />
      For address changes, notify{" "}
      <a href="mailto:support@wellinks.com">support@wellinks.com</a> in addition to
      updating.
    </p>

    <div className="appointment-overlay__verify-actions">
      <button
        type="button"
        className="appointment-overlay__footer-btn appointment-overlay__footer-btn--primary"
        onClick={onVerify}
      >
        Patient verified
      </button>
    </div>
  </div>
);

export default AppointmentOverlayVerification;
